import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { toast } from 'react-toastify';
import { CloseButton, CreateChancel, ToastScreen, ValidationInput } from 'components';
import { ErrorText, FindError, FindLoad, useGlobalStyles, useGlobalTextStyles } from 'utils';
import { httpRequestsOnErrorsActions, loadActions } from 'store';

const ACTION_TYPE = 'CREATE_LOADS_BATCH';

export const AddPayoutDate = ({ selectedLoads, fromBatch, handleClose }) => {
  const [inputValues, stInputValues] = useState({
    name: '',
    payoutDate: '',
  });
  const [errors, setErrors] = useState({
    name: false,
    payoutDate: false,
  });
  const dispatch = useDispatch();
  const load = FindLoad(ACTION_TYPE);
  const beckError = FindError(ACTION_TYPE);
  const globalText = useGlobalTextStyles();
  const globalStyles = useGlobalStyles();


  useEffect(() => {
    if (beckError?.[0]?.error) {
      dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));

      toast(
        <ToastScreen
          type={'error'}
          text={beckError?.[0]?.error}
        />,
      );
    }

  }, [beckError?.[0]?.error]);


  const handleChange = (path, value) => {
    stInputValues(prev => ({
      ...prev,
      [path]: value,
    }));

    setErrors(prev => ({
      ...prev,
      [path]: false,
    }));
  };

  const handleCreate = () => {
    if (inputValues?.name?.trim() && inputValues?.payoutDate) {
      const body = {
        loadIds: selectedLoads?.map((load) => load?.id),
        name: inputValues?.name,
        payoutDate: moment(inputValues?.payoutDate).format('YYYY-MM-DD'),
      };

      if (fromBatch) body.fromBatch = fromBatch;
      if (selectedLoads?.length) body.loadIds = selectedLoads.map((load) => load?.id);

      dispatch(loadActions.createBatch(body));
    } else {
      setErrors(prev => ({
        name: !inputValues?.name?.trim(),
        payoutDate: !inputValues?.payoutDate,
      }));
    }
  };


  return (
    <div className='add-payout-date-wrapper'>
      <div className='add-payout-date-close-btn'>
        <CloseButton handleCLic={handleClose} />
      </div>

      <p className={globalText.modalTitle} style={{ marginBottom: 32 }}>
        Create Batch
      </p>

      <ValidationInput
        className={inputValues?.name && globalStyles.inputTextFieldBlue}
        variant={'outlined'}
        name={'name'}
        label={'Name*'}
        typeError={errors?.name ? ErrorText.field : ''}
        onChange={(e) => handleChange('name', e?.target.value)}
        value={inputValues?.name}
      />

      <ValidationInput
        className={inputValues?.payoutDate && globalStyles.inputTextFieldBlue}
        variant={'outlined'}
        name={'availableDate'}
        type={'date'}
        label={'Date*'}
        typeError={errors?.payoutDate ? ErrorText.field : ''}
        onChange={(e) => handleChange('payoutDate', e?.target.value)}
        value={inputValues?.payoutDate}
        min={moment().format('YYYY-MM-DD')}
      />

      <CreateChancel
        loader={!!load?.length}
        create={'Create Batch'}
        chancel={'Cancel'}
        onCreate={handleCreate}
        onClose={handleClose}
        width='100%'
      />
    </div>
  );
};

